<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="new-hv-paket-selection" id="zusatzpakete">
    <div *ngIf="hvHaushaltPakete | async as hvHaushaltPakete">
      <div class="new-hv-paket-selection-container" *ngIf="hvHaushaltPakete.length > 0">
        <div class="new-hv-paket-selection-infotext">Haushalt</div>
        <div class="new-hv-paket-selection-item-container">
          <div class="new-hv-paket-selection-item" *ngFor="let paket of hvHaushaltPakete" (click)="showPaket(paket)">
            <div class="new-hv-paket-icon-small" [ngClass]="{'new-hv-paket-icon-previewed': previewPaket === paket, 'new-hv-paket-icon-selected': isSelected(paket)}">
              <img src="{{ dataService.hvPaketIcons.get(paket.Kategorie) }}">
            </div>
            <div class="new-hv-paket-text-small" [ngClass]="{'new-hv-paket-text-small-selected': (previewPaket === paket || isSelected(paket))}">{{ dataService.hvPaketShortenedNames.get(paket.Kategorie) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="hvEigenheimPakete | async as hvEigenheimPakete">
      <div *ngIf="hvEigenheimPakete.length > 0">
        <div class="new-hv-paket-selection-separator" *ngIf="(hvHaushaltPakete | async)?.length > 0"></div>
        <div class="new-hv-paket-selection-container">
          <div class="new-hv-paket-selection-infotext">Eigenheim</div>
          <div class="new-hv-paket-selection-item-container">
            <div class="new-hv-paket-selection-item" *ngFor="let paket of hvEigenheimPakete" (click)="showPaket(paket)">
              <div class="new-hv-paket-icon-small" [ngClass]="{'new-hv-paket-icon-previewed': previewPaket === paket, 'new-hv-paket-icon-selected': isSelected(paket)}">
                <img src="{{ dataService.hvPaketIcons.get(paket.Kategorie) }}">
              </div>
              <div class="new-hv-paket-text-small" [ngClass]="{'new-hv-paket-text-small-selected': (previewPaket === paket || isSelected(paket))}">{{ dataService.hvPaketShortenedNames.get(paket.Kategorie) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div formArrayName="zusatzpakete" *ngIf="hvPakete | async as hvPakete">
    <div *ngFor="let zusatzpaket of zusatzpakete.controls;let i=index">
      <div class="col col-xs-12 col-sm-12">
        <app-hv-paket [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="zusatzpaket" [produktart]="hvPakete[i].Produktart" [paket]="hvPakete[i].Paket" [previewPaket]="previewPaket" (calculateRatePendingEvent)="onCalculateRatePending($event)"></app-hv-paket>
      </div>
    </div>
  </div>
</form>
